import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { WMComponent } from '@front/webmobile/Views/Components/WMComponent';
import { VerticalDetailsItemViewModel } from '../../../ViewModels/VerticalDetailsItemViewModel';
export class VerticalDetailsItem extends WMComponent {
    constructor(props) {
        super(props, (VerticalDetailsItemViewModel));
        this.onMouseDown = this.onMouseDown.bind(this);
    }
    onMouseDown(event) {
        this.viewModel.onMouseDown(event);
    }
    render() {
        const { rowName, rowNameTooltip, rowValueTooltip, firstRowValue, secondRowValue, firstValueColor, secondValueColor } = this.state;
        return (_jsxs("div", { className: "account-details-item", onMouseDown: this.onMouseDown, children: [_jsx("div", { className: "item-name", "data-tooltip": rowNameTooltip, children: rowName }), _jsxs("div", { className: "item-value", "data-tooltip": rowValueTooltip, children: [_jsx("div", { className: `value ${firstValueColor}`, children: firstRowValue }), secondRowValue && (_jsxs(_Fragment, { children: [_jsx("div", { children: "/" }), _jsx("div", { className: `value ${secondValueColor}`, children: secondRowValue })] }))] })] }));
    }
}
